var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"study"},[_c('div',{staticClass:"study__container col-11 col-sm-10 m-auto",attrs:{"data-aos":"fade-up","data-aos-duration":"500","data-aos-offset":"300"}},[_c('div',{staticClass:"study__title"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.sub))])]),_c('Slider',{attrs:{"data":_vm.dataSlider}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }